// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {createContext} from 'react';

export const Form_content_ctx = createContext({});
export const Form_controls_ctx = createContext({});
export const Form_validity_ctx = createContext({});
export const Form_meta_ctx = createContext({});
export const Form_disabled_ctx = createContext(false);
